<template>
    <portal to="blank">
        <div class="fixed inset-0 overflow-hidden" style="z-index:99999" v-if="show" aria-labelledby="slide-over-title"
             role="dialog" aria-modal="true">
            <div class="absolute inset-0 overflow-hidden">

                <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"
                     @click.prevent="close()"></div>

                <div class="fixed inset-y-0 right-0 sm:pl-10 max-w-full flex">

                    <div class="relative w-screen" :class="widthClass">

                        <div class="absolute top-0 right-0 flex -ml-10 p-4 z-10" v-if="closable">
                            <button @click.prevent="close"
                                    class="text-2xl rounded-md text-brand hover:text-brand-light focus:outline-none focus:ring-2 focus:ring-brand-dark">
                                <span class="sr-only">Close panel</span>
                                <i class="fas fa-times-square"></i>
                            </button>
                        </div>

                        <div class="h-full flex flex-col py-4 my-0 bg-white shadow-xl" :class="scrollable?'overflow-y-scroll':'overflow-y-hidden'">
                            <div class="px-4 sm:px-6">
                                <h2 class="text-xl font-medium text-gray-900" id="slide-over-title">
                                    <slot name="title">{{ title }}
                                        <span v-if="shortcut" class="text-gray-300 text-sm mt-0 ml-2"><span
                                            class="far fa-keyboard mr-1"></span>{{ shortcut }}</span>
                                    </slot>
                                </h2>
                            </div>
                            <div class="relative flex-1" ref="slideovercontainer"
                                 :class="contentClass">
                                <slot/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway';

export default {
    mixins: [clickaway],
    props: {
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        shortcut: {
            type: String,
            required: false,
            default: ''
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        contentClass: {
            type: String,
            required: false,
            default: 'mt-6 px-4 sm:px-6 overflow-y-auto '
        },
    },
    data() {
        return {
            show: false,
            wide: false,
            scrollable : true
        }
    },
    computed: {
        widthClass() {
            return this.wide?'sm:max-w-screen-lg':'sm:max-w-md'
        },
        slideoverKey() {
            var key = '';
            if (this.name) {
                key = '-' + this.name;
            }

            return key;
        }
    },
    methods: {
        close(event) {
            this.show = false;
            eventBus.$emit('slideover-closed' + this.slideoverKey);
            eventBus.$emit('slideover-closed',this.slideoverKey);
        },
        open() {
            this.show = true;
            eventBus.$emit('slideover-opened' + this.slideoverKey);
            eventBus.$emit('slideover-opened',this.slideoverKey);
        },
        scrollToTop: function () {
            let container = this.$refs.slideovercontainer;

            // We need to delay this a little bit to allow the browser time to render
            // the new data before we actually scroll to the bottom of the container.
            setTimeout(function () {
                if (!_.isUndefined(container)) {
                    container.scrollTop = 0;
                }
            }, 50);
        },
        scrollAmount: function (amount) {
            let container = this.$refs.slideovercontainer;
            this.$nextTick(() => {
                if (!_.isUndefined(container)) {
                    container.scrollTop += amount;
                }
                setTimeout(() => {
                    if (!_.isUndefined(container)) {
                        container.scrollTop += amount;
                    }
                }, 50);
            })
        },
        scrollTo: function (to) {
            let container = this.$refs.slideovercontainer;
            this.$nextTick(() => {
                if (!_.isUndefined(container)) {
                    container.scrollTop = to;
                }
                setTimeout(() => {
                    if (!_.isUndefined(container)) {
                        container.scrollTop = to;
                    }
                }, 50);
            })
        },
        scrollToBottom: function () {
            let container = this.$refs.slideovercontainer;

            // We need to delay this a little bit to allow the browser time to render
            // the new data before we actually scroll to the bottom of the container.
            this.$nextTick(() => {
                if (!_.isUndefined(container)) {
                    container.scrollTop = container.scrollHeight;
                }
            })
            setTimeout(function () {
                if (!_.isUndefined(container)) {
                    container.scrollTop = container.scrollHeight;
                }
            }, 50);
        },
    },
    mounted() {
        var that = this;

        eventBus.$on('slideover-scroll-top', function (closure) {
            that.scrollToTop();
        });
        eventBus.$on('slideover-scroll', (amount) => this.scrollAmount(amount))
        eventBus.$on('slideover-scroll-to', (to) => this.scrollTo(to))

        eventBus.$on('slideover-scroll-bottom', function (closure) {
            that.scrollToBottom();
        });
        eventBus.$on('slideover-open' + this.slideoverKey, function (closure) {
            that.open();
        });
        eventBus.$on('slideover-set-wide-mode' + this.slideoverKey, (wideMode)=> {
            this.wide = wideMode
        })

        eventBus.$on('slideover-set-scrollable' + this.slideoverKey, (scrollable)=> {
            this.scrollable = scrollable
        })

        eventBus.$on('slideover-close' + this.slideoverKey, function (closure) {
            that.close();
        });
    }
}
</script>
